import { Navigate, Outlet } from 'react-router-dom'
import { canAccessSurface, type AdminSurface } from '@/auth/surfaces'
import { useAuth } from '@/contexts/use-auth'

/**
 * DEC-ADMIN-013 — client-side surface guard. Chained inside RequireAuth: if the
 * logged-in admin's role may not access this surface, redirect to the home hub.
 * The backend `admin.surface` middleware is the real gate (403); this only keeps
 * the UI honest (no dead screens, no direct-URL access to a foreign surface).
 */
export function RequireSurface({ surface }: { surface: AdminSurface }) {
  const { authUser } = useAuth()

  if (!canAccessSurface(authUser?.role, surface)) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
